module.exports = __webpack_public_path__ + "static/media/scenario10yar.d9881047.jpg";